/**
 * Search input component. User input for the search.
 */
import Caret from '@components/atoms/text/searchCaret';
import Container from '../../atoms/container/searchInputContainer';
import Focus from '@shared/types/enums/focus';
import FocusUtils from '@shared/utils/focus';
import Icon from '../../atoms/icons/searchIcon';
import Input from '../../atoms/text/searchInput';
import OpacityAnimation from '@components/utils/helpers/opacityAnimation';
import Results from '../../atoms/text/searchResultsText';
import TranslationManager from '../../../../shared/assets/locale/translationsManager';
import { focusSelector } from '@shared/store/slices/focus.slice';
import { useAppSelector } from '@shared/store/hooks';

/**
 * Search input component props
 */
interface Props {
  input?: string;
  error: boolean;
  results: number;
  searching?: boolean;
  selection?: string;
}

/**
 * Search input component. Rendereed above the search results.
 */
export default function SearchInput({
  error,
  input,
  results,
  selection,
  searching,
}: Props) {
  // Selectors
  const { focus } = useAppSelector(focusSelector);

  // Constants
  const caret = focus === Focus.SEARCH_KEYBOARD;
  const showInput =
    !FocusUtils.evaluateFocus(Focus.RAILS_LIST) &&
    !FocusUtils.evaluateFocus(Focus.FLOATING_MENU);
  const message =
    results && selection && !error
      ? TranslationManager.get(
          'COMPONENTS.SEARCH.RESULT' + (results > 1 ? 'S' : ''),
          results.toString(),
          selection || ''
        )
      : null;

  // Render
  return showInput ? (
    <OpacityAnimation>
      <Container>
        <Icon />
        <Input>
          {input?.toUpperCase() || ''}
          {caret ? <Caret>{'|'}</Caret> : null}
        </Input>
        <Results
          dangerouslySetInnerHTML={{
            __html: !searching ? message || '' : '',
          }}
        />
      </Container>
    </OpacityAnimation>
  ) : null;
}
